import * as e from "react";
const t = (c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...c
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.091 8.13V5.156h-.623v-.731c.432 0 .696-.142.793-.425h.75v4.13h-.92zm-1.033 5.9c0-.406.067-.763.2-1.074.133-.311.3-.56.503-.75.201-.188.451-.363.75-.525.174-.09.307-.18.4-.271a.429.429 0 00.145-.325c0-.27-.15-.407-.448-.407-.29 0-.51.138-.66.413l-.823-.36c.13-.279.325-.499.587-.66a1.64 1.64 0 01.866-.242c.427 0 .764.116 1.01.348.25.232.376.523.376.873 0 .327-.075.584-.224.773-.146.189-.37.368-.672.537a4.77 4.77 0 00-.636.425c-.129.106-.228.234-.296.383H6v.862H3.058zm.523 5.71c.27.174.59.26.956.26.428 0 .775-.11 1.041-.33.267-.225.4-.506.4-.844 0-.252-.06-.464-.182-.637a.953.953 0 00-.448-.36c.331-.213.497-.517.497-.915 0-.35-.123-.635-.37-.855-.246-.22-.568-.33-.968-.33-.307 0-.579.076-.817.23-.234.153-.42.364-.557.631l.823.313c.138-.217.317-.325.539-.325.137 0 .244.04.32.118.081.079.122.177.122.295a.445.445 0 01-.115.325.431.431 0 01-.315.112h-.46v.861h.46c.182 0 .32.041.418.124a.37.37 0 01.145.29.402.402 0 01-.145.33.596.596 0 01-.388.117c-.298 0-.536-.151-.714-.454L3 19.021c.121.306.315.546.581.72zM20.222 5.2H7.778c-.43 0-.778.448-.778 1s.348 1 .778 1h12.444c.43 0 .778-.448.778-1s-.348-1-.778-1zm0 6H7.778c-.43 0-.778.448-.778 1s.348 1 .778 1h12.444c.43 0 .778-.448.778-1s-.348-1-.778-1zm-12.444 6h12.444c.43 0 .778.448.778 1s-.348 1-.778 1H7.778c-.43 0-.778-.448-.778-1s.348-1 .778-1z",
      fill: "#2d6ded"
    }
  )
), l = t;
export {
  l as default
};
